import { Check, Clock, X } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { InvoiceEmailExclamationIcon } from './invoice-email-exclamation-icon';

import type { InvoiceEmailBadgeState } from '../derive-invoice-email-badge';

type InvoiceEmailStatusBadgeProps = {
  state: InvoiceEmailBadgeState;
};

/** Small corner indicator on the size-8 mail trigger — not full size-7 status glyphs. */
const badgeWrap =
  'absolute -right-0 -top-0 z-[1] flex size-4 items-center justify-center rounded-full shadow-sm ring-1 ring-white dark:ring-gray-900';

const badgeRed = 'bg-error-dark text-white';

const badgeGreen = 'bg-success-dark text-white';

const badgeYellow = 'bg-warning text-white';

const badgeBlue = 'bg-info text-white';

const badgeIconClass = 'size-3.5 shrink-0 text-white';

export function InvoiceEmailStatusBadge({ state }: InvoiceEmailStatusBadgeProps) {
  if (state === 'none') {
    return null;
  }

  if (state === 'warning') {
    return (
      <span className={twMerge(badgeWrap, badgeRed)} aria-hidden>
        <InvoiceEmailExclamationIcon className={badgeIconClass} />
      </span>
    );
  }

  if (state === 'pending') {
    return (
      <span className={twMerge(badgeWrap, badgeYellow)} aria-hidden>
        <Clock className={badgeIconClass} strokeWidth={2.5} />
      </span>
    );
  }

  if (state === 'scheduled') {
    return (
      <span className={twMerge(badgeWrap, badgeBlue)} aria-hidden>
        <Clock className={badgeIconClass} strokeWidth={2.5} />
      </span>
    );
  }

  if (state === 'success') {
    return (
      <span className={twMerge(badgeWrap, badgeGreen)} aria-hidden>
        <Check className={badgeIconClass} strokeWidth={2.5} />
      </span>
    );
  }

  return (
    <span className={twMerge(badgeWrap, badgeRed)} aria-hidden>
      <X className={badgeIconClass} strokeWidth={2.5} />
    </span>
  );
}
